/**
 * 退出，清除cookie
 * @param  {String} targetUrl 跳转的url
 * @return {Void}
 */
import config from "@/constants/config.js"
import cookie from "@/utils/cookie.js"
import { logout as logoutCgi } from "@/api/operator/cgi/smb/common/index.js"

export const logout = (targetUrl = "") => {
  const cookies = ["uin", "skey", "zzpaneluin", "zzpanelkey"]
  const currentDomainCookies = ["elogininfo", "gdt_elogin", "bm_id", "agency_uid", "agency_uid_gdt", "agency_uid_wx", "agency_uid_cps"]
  let i = 0,
    len = 0

  i = 0
  len = cookies.length

  for (; i < len; i++) {
    cookie.del(cookies[i], config.SITE.parentDomain, "/")
  }

  i = 0
  len = currentDomainCookies.length
  for (; i < len; i++) {
    cookie.del(currentDomainCookies[i], config.SITE.domain, "/")
  }
  //清空自定义列表信息
  window.localStorage.removeItem("customizeColumns")
  window.sessionStorage.removeItem("knowledge_token")
  logoutCgi().then(
    (response = {}) => {
      if (response.code == 0) {
        if (targetUrl) {
          top.location.href = targetUrl
        } else {
          top.location.href = config.SITE.portalUrl
        }
      } else {
        alert(response.msg || "退出失败，请重试！")
      }
    },
    (response) => {
      alert("退出失败，请重试！")
    }
  )
}
